import template from './socialSecurityHeaderEmployee.html';
import './socialSecurityHeaderEmployee.scss';

let socialSecurityHeaderEmployeeComponent = {
  restrict: 'E',
  bindings: {
    employeeData: '<',
  },
  template
};

export default socialSecurityHeaderEmployeeComponent;



// WEBPACK FOOTER //
// ./client/app/social-security.module/components/socialSecurityHeaderEmployee/socialSecurityHeaderEmployee.component.js